import React from 'react';
import {FilePdfOutlined} from "@ant-design/icons";
import {Button} from "antd";
import {getPdfViewerType, PdfViewerType} from "./config";
import styled from 'styled-components';

const StyledDownloadButtonDiv = styled.div`
    &.alternative-viewer {
        .inner {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
        }

        .icon-and-text {
            margin-bottom: 6px;
        }
    }
`;

/**
 * Using Browser's own PDF Viewer using Iframe
 */
export function NativeIframeViewer({pdfUrl}) {
    return <iframe title="PDF Viewer" src={pdfUrl} width="100%" height="100%" />;
}

/**
 * Using custom-built download button only (final fallback)
 */
export function OnlyDownloadButton({pdfUrl}) {
    return (
        <StyledDownloadButtonDiv className="alternative-viewer">
            <div className="inner">
                <div className="icon-and-text">
                    <FilePdfOutlined style={{ fontSize: '48px'}} />
                    <div className="text">PDF</div>
                </div>
                <a href={pdfUrl}>
                    <Button type="primary">Open</Button>
                </a>
            </div>
        </StyledDownloadButtonDiv>
    );
}

/**
 * Using the newest Pdf.js approach
 */
export function PdfJsViewer({pdfUrl}) {
    return <iframe
        title="PDF Viewer"
        src={`/pdf/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`}
        width="100%"
        height="100%"
    />;
}

export function PdfViewer({pdfUrl}) {
    if (!pdfUrl)
        return null;

    const viewerType = getPdfViewerType();
    switch (viewerType) {
        case PdfViewerType.pdfJsIframe:
            return <PdfJsViewer pdfUrl={pdfUrl} />;
        case PdfViewerType.nativeIframe:
            return <NativeIframeViewer pdfUrl={pdfUrl} />;
        case PdfViewerType.onlyDownloadButton:
        default:
            return <OnlyDownloadButton pdfUrl={pdfUrl} />;
    }
}
